import { ArticleStructure } from "../../articleElement.js";

const PhDFinalSeminar = new ArticleStructure(
    "Final Seminar @ QUT",
    "FinalSeminar2024A"
) 

PhDFinalSeminar.addYoutubeSection(
"https://www.youtube.com/embed/0laVKLJye9g",
"A short introduction to process mining with exogenous data.",
`
If you are after a quick introduction to my thesis, then the clip below 
discusses the motivation of the contributions presented in my thesis.
`,
`
However, if you interested in hearing about the journey towards a doctorate
at the Queendland University of Techonology, or at least my own experience, 
then read on. At the end of the blog, a full recording of the final seminar 
is included for the interested <br>(see this <a href="#clip-2"><u>clip</u></a>).
`
)

PhDFinalSeminar.addTextSection(
`
Reflecting on the past three years of my candidature, my final seminar 
represents the beginning of the closure of the candidature. The Australian 
system for PhDs, or at least the procedures at my university (Queensland  
University of Technology), consists of several phases which lead to a 
candidate receiving a doctorate. A successful candidate must pass all of 
these phases with a recommendation for the university to confer the doctorate.
`
)

PhDFinalSeminar.addQuote(
`
Queensland University milestone phases, on which my candidature followed, consisted of five key phases:
<ul style="text-align: left;width:80%;margin:auto;">
    <li> <b>Stage Two Report:</b> due by third month;</li>
    <li> <b>Confirmation of Candidature:</b> due by the twelveth month;</li>
    <li> <b>Annual Progress Report:</b> due by the 24th month, and then every 12 
    month after;</li>
    <li> <b>Final Seminar:</b> due by the 36th month of the candidature;</li>
    <li> <b>Lodgement of thesis for examination:</b> due shorty after final seminar 
    (usually within 3 months).</li>
</ul>
`,
"Queensland University of Technology, 2024"
)

PhDFinalSeminar.addTextSection(
`
Across these milestone phases, the progress of my candidature has been positive, 
and in some cases, minor adjustments were expected to improve the chances of
 being conferred with a doctorate. The final seminar requires 
that a candidate submit the final draft of the thesis and present a seminar 
to a panel of peers on their research project. Afterwards, the panel will 
provide recommendations based on the thesis and seminar. Also, the panel's 
outcome will decide whether the candidate can proceed to lodgement. Usually
the panel consists of one supervisor for the candidate, one member from the 
supporting school for the candidate, and a member from outside the supporting
school. My Panel consisted of the following three members:
`
)

PhDFinalSeminar.addProfile("Professor Moe T Wynn", "moe-wynn.png",
`
Prof. Wynn leads the Process Science Academic Program (formerly Business Process 
Management) and is the Academic Lead of Research for the School of Information 
Systems, Queensland University of Technology. She co-leads the Data for 
Discovery Program within QUT’s Centre for Data Science. She has been appointed 
as a member of the Australian Research Council College of Experts for the 
period of 3 years (2023 – 2025).
She conducts research in the areas of business process management, workflow 
management, process mining and data quality, having completed her PhD in 
workflow management, and process automation. She is recognised internationally 
for her contributions to the formal foundations of process modelling, 
verification, automation, and process-oriented data mining (process mining).
`,
"L"
)
PhDFinalSeminar.addProfile("Doctor Alizera Nili", "alizera-nili.jpeg",
`
Dr. Alizera Nili is a Senior Lecturer in Service Science. He investigates 
digitisation of services from the customer-centric perspective, design and 
evaluate personalised digital services, and propose and evaluate solutions for 
increasing trust and confidence in the services (user level and organisational 
level). He proposes and validates frameworks, guiding principles, and theories 
to achieve these goals. He is a Level 3 (mentoring) PhD supervisor with 
award-winning PhD graduates. His research focuses on several types of digital 
services and technologies such as Internet of Things (IOT), Industrial IOT 
(IIOT), artificial intelligence (particularly chatbots), social media platforms, 
and technologies for sustainability. His research is domain-independent, but 
he has have been particularly interested in digital public services and retail 
technologies.
`,
"R"
)
PhDFinalSeminar.addProfile("Adjunct Professor Colin Fidge", "colin-fidge.png",
`
Prior to his retirement Prof. Colin Fidge pursued a four-decade teaching and 
research career in high-integrity software engineering, modelling and analysis 
of complex, computer-based systems, and enterprise system re-engineering. In 
retirement he continues to advise on research in the Schools of Computer 
Science and Information Systems, Queensland University of Technology. He has 
been awarded 17 Australian Research Council grants, and led nine research 
projects for industry and the Australian Department of Defence, mainly in the 
fields of safety-critical and security-critical systems. He graduated 25 PhD 
students and 4 Research Masters students.
`,
"L"
)
PhDFinalSeminar.addTextSection(
`
It is important to distinguish that the final seminar, is not like the public
defence in the European system. The panel does not confer the doctorate but 
instead acts as an internal step towards the lodgement for examination. 
<i>Only after a successful external examination from at least two scholars 
outside the university does the candidate have their doctorate conferred.</i> 
However, the panel does 
have other options besides recommending the lodgement. The most common 
outcome is that the panel recommends minor changes and gives candidates 
one to three months to enact changes based on their feedback.
<b>In my case, the panel provided feedback and recommended minor changes with 
a month to enact them.</b> 
The other possible outcomes that the panel can recommend are as follows:
`
)
PhDFinalSeminar.addQuote(
`
Queensland University of Technology outlines that the panel of a final seminar 
can recommend the following:
<ul style="padding-top:5px;padding-bottom:5px;text-align: left;width:80%;
margin:auto;">
    <li> <b>(minor/major changes)</b> indicate the time remaining for you 
    to finalise and lodge your thesis for examination;</li>
    <li> <b>(review)</b> place the candiate under review for up to 3 months 
    if the panel has concerns about your work meeting award standards.
    </li>
</ul>
If your progress is still unsatisfactory after the under review period, the 
Research Degrees Committee - on advice from the faculty committee - will 
either:
<ul style="padding-top:5px;text-align: left;width:80%;margin:auto;">
    <li> extend the review period by up to 3 months; </li>
    <li> allow you to Show Cause why the committee should not either: </li>
    <ul style="margin-left: 25px">
        <li> academically exclude you with an offer of admission to the 
        degree of Master of Philosophy;</li>
        <li> academically exclude you with no such offer.</li>
    </ul>
</ul>
`,
"Queensland University of Technology, 2024"
)

PhDFinalSeminar.addTextSection(
`
I completed my Final Seminar on 21st of August 2024, from 14:30 to 16:00. 
After which, I updated the thesis draft using the panel's feedback and began 
the lodgement process on the 24th of September 2024. It was accepted 
internally to be sent to examinators by the 5th of November, 2024. The 
acceptance of the lodgement signals the end of the journey for the candidate 
at the university, which means they lose financial backing, resources, and 
allocations (desk, computers, servers, etc.) are returned to the university. 
<b>While I am proud of my work, the ending phase is largely not a celebration 
period. I have gone as far as to dub as being in '<i>PhD Limbo</i>' and doing 
all you can to scrap together enough for rent.</b> Many other candidates who 
have made it to the actual graduation ceremony (some 18 months after lodgement) 
describe the ceremony as making the doctorate feel ''<i>real</i>'' afterwards. 
I hope to get to that point and find an opportunity to use my expertise in 
academia.
`
)

PhDFinalSeminar.addTextSection(
`
But let's not dwell on despair; instead, let's revisit what was a successful 
three-year research plan. The plan had a budget of $3000 AUD or roughly
&euro; 1,800 for the three years, and I managed to publish three times, 
which meant I was well over budget (thankfully, my wonderful supervisers 
covered the overdraw). It started in the middle of the COVID-15 pandemic, 
and while Brisbane didn't 
have long periods of lockdowns due to the somewhat low reporting of cases, 
it still meant a lot of working from home. 
During my candidature, I learned I can do my best when collaborating and 
discussing with colleagues, but Zoom meetings aren't enough to have a 
meaningful conversation—too many context switches. Also, having a supervisor 
move on to greener grounds on the opposite side of the world around your 
confirmation meant I had to rework my research plan. Nonetheless, I did my 
best to work with my supervisors, and they persevered through all the 
late/early meetings to discuss my work. As I revisit and re-record my final 
seminar, I am starting to feel a sense of pride for having made it this far. 
I hope that you see that over this candidature, I have developed expertise 
in process science and have the potential to make it in academia.
`
)

PhDFinalSeminar.addYoutubeSection(
"https://youtube.com/embed/u7f8Fx6BubY",
"Adam Banham, 2024, Final Seminar, Process Mining with Exogenous Data",
`
This clip is a re-recording of the final seminar that I presented in 
August 2024.
`,
""
)

export default PhDFinalSeminar